import request from '@/utils/request'

// 统一的 API 封装
export const api = {
    get(url, params = {}) {
        return request({
            url,
            method: 'GET',
            params
        })
    },

    post(url, data = {}) {
        return request({
            url,
            method: 'POST',
            data
        })
    },

    put(url, data = {}) {
        return request({
            url,
            method: 'PUT',
            data
        })
    },

    delete(url) {
        return request({
            url,
            method: 'DELETE'
        })
    }
}